exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* clear fix */\n.grid[data-v-6d11f65b]:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.grid-item[data-v-6d11f65b] {\n  float: left;\n  padding-bottom: 30px;\n}\n.grid-item .gallery-image[data-v-6d11f65b] {\n  width: 100%;\n  -webkit-filter: sepia(0.3);\n          filter: sepia(0.3);\n}\n.grid-item .gallery-image[data-v-6d11f65b]:hover {\n  -webkit-filter: none;\n          filter: none;\n}", ""]);

// exports
